import AcceleratorDoc from "../AcceleratorDoc";
import { BaseField } from "../extraction/BaseField";
import { RunDlfReuse, RunDlfReuseResponse } from "./RunDlfReuse";

class DlfReuseGenerator {
  fieldName: string;
  constructor(fieldName: string) {
    this.fieldName = fieldName;
  }

  async calculate(
    acceleratorDoc: AcceleratorDoc,
  ): Promise<BaseField[] | undefined> {
    const response = await this.callApi(acceleratorDoc);
    if (!response) {
      //console.warn(`Error calling API to calculate reuse`);
      return undefined;
    }
    return this.getResults(response);
  }

  getResults(response: RunDlfReuseResponse): BaseField[] {
    if (!response.valid) {
      console.warn(
        `Could not calculate reuse for DLF:${this.fieldName}`,
        response!.reason,
      );
      // console.log(response!.reason);
    }
    // filter out BaseFields without matcherData
    const filtered = response.results.filter((x) => x._matcherData);
    // set KVs to ERROR if confidence below threshold
    filtered
      .filter((x) => x.matcherData.discriminator === "F_KEYVALUE")
      .filter((x) => x.confidence <= x.matcherData.threshold)
      .forEach((x) => (x.fieldStatus = "ERROR"));
    return filtered;
  }

  async callApi(
    acceleratorDoc: AcceleratorDoc,
  ): Promise<RunDlfReuseResponse | null> {
    return new RunDlfReuse(
      acceleratorDoc.classifiedDocType,
      this.fieldName,
    ).calculate(acceleratorDoc);
  }
}

export { DlfReuseGenerator };
